module.exports = __webpack_public_path__ + "static/media/logoPlanet.dd4e70ba.png";